import { inlineMedia as mapInlineMedia, type InlineMedia } from "@ccnote/shared";
import { attachmentUrl, type Attachment } from "./api";

export { baseName, isInlineImage, isVideo, type InlineMedia } from "@ccnote/shared";

export function mediaUrl(noteId: string, a: Attachment): string {
  return a.url ?? attachmentUrl(noteId, a.id, true);
}

/** The same file offered as a download (the media host sends it as an attachment). */
export function downloadUrl(noteId: string, a: Attachment): string {
  const url = mediaUrl(noteId, a);
  return a.url ? `${url}&dl=1` : attachmentUrl(noteId, a.id);
}

export function inlineMedia(noteId: string, attachments: Attachment[]): InlineMedia {
  return mapInlineMedia(attachments, (a) => mediaUrl(noteId, a));
}
